import { DownOutlined } from '@ant-design/icons'
import {
  Button,
  Dropdown,
  Flex,
  Pagination,
  Table,
  type TableColumnsType
} from 'antd'
import type { TableProps } from 'antd/lib'

import { useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'

import { detailsTableData, ReportFilesType } from '../data'

const menuDropdownItems = Object.values(ReportFilesType).map((item) => ({
  label: item,
  key: item
}))

export const ReportDetailsTable = ({ ...props }: TableProps) => {
  const { t } = useLocales()
  const pagination = useTablePagination()

  const columns: TableColumnsType = [
    {
      key: 'nr',
      title: 'Nr.',
      render: (_, __, index) => index + 1,
      sorter: (a, b) => a.id - b.id,
      width: 70
    },
    {
      key: 'contract_date',
      width: 270,
      title: t('reports.contract_date'),
      dataIndex: 'contract_date',
      sorter: (a, b) => a.contract_date.localeCompare(b.contract_date)
    },
    {
      key: 'type',
      title: t('common.type'),
      dataIndex: 'type',
      sorter: (a, b) => a.type.localeCompare(b.type)
    },
    {
      key: 'product',
      title: t('common.product'),
      dataIndex: 'product',
      sorter: (a, b) => a.product.localeCompare(b.product)
    },
    {
      key: 'group',
      title: t('common.group'),
      dataIndex: 'group',
      sorter: (a, b) => a.group.localeCompare(b.group)
    },
    {
      key: 'um',
      title: 'UM',
      dataIndex: 'um',
      sorter: (a, b) => a.um.localeCompare(b.um)
    },
    {
      key: 'contract_quantity',
      title: t('reports.contract_quantity'),
      dataIndex: 'contract_quantity',
      sorter: (a, b) => a.contract_quantity.localeCompare(b.contract_quantity)
    },
    {
      key: 'contract_value',
      title: t('reports.contract_value'),
      dataIndex: 'contract_value',
      sorter: (a, b) => a.contract_value.localeCompare(b.contract_value)
    },
    {
      key: 'amount_purchase',
      title: t('reports.amount_purchase'),
      dataIndex: 'amount_purchase',
      sorter: (a, b) => a.amount_purchase.localeCompare(b.amount_purchase)
    }
  ]

  return (
    <Table
      rowKey="id"
      columns={columns}
      pagination={false}
      footer={() => (
        <Flex justify="space-between">
          <Dropdown menu={{ items: menuDropdownItems }} placement="bottom">
            <Button icon={<DownOutlined />} type="primary">
              {t('reports.export_report')}
            </Button>
          </Dropdown>

          <Pagination {...pagination} total={detailsTableData?.length} />
        </Flex>
      )}
      scroll={{ x: 'max-content' }}
      {...props}
    />
  )
}
